module.exports = __webpack_public_path__ + "img/67.1c7f9cd3.jpg";